<template>
  <div id="history-screen" translate="no">
    <Loading
      :active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      :height="40"
      loader="spinner"
      color="#003340"
    ></Loading>
    <BackToServices
      :table="tableId"
      :storeName="storeName"
      :isApplication="isApplication"
      :hasBoxShadow="true"
      :amountOfDepartments="2"
      :goBackToOpenTables="false"
      :pdaMobileScreen="false"
      :restaurantType="'CATALOGUE'"
      id="back-to-services"
    ></BackToServices>
    <div id="banner">
      <img v-if="store" id="banner-image" :src="`${store.bannerLink}`" alt />

      <div id="store-info">
        <Store id="store" :store="store" :shouldShowMenu="false"></Store>
      </div>

      <div id="upper-bar">
        <div id="logo-container" v-if="!isApplication">
          <a id="link-to-landing" href>
            <img id="logo" src="../../assets/Full_logo-Black.svg" alt />
          </a>
        </div>
        <div id="profile-and-cart">
          <LanguageSelect
            id="language-select"
            :class="{ 'language-position-in-login': isLoggedIn }"
          ></LanguageSelect>

          <ProfileDropdown
            v-if="isLoggedIn"
            id="profile-dropdown"
            :isApplication="isApplication"
            :class="{ 'profile-dropdown-with-lang-select': isAbleToChangeLanguage,
                    'profile-dropdown-without-lang-select': !isAbleToChangeLanguage }"
          ></ProfileDropdown>
          <EnterPrompt
            v-else-if="shouldShowEnterPrompt && !isLoggedIn && !isApplication"
            @enter-clicked="initiateEntrance"
            id="enter-prompt"
            :class="{ 'enter-prompt-with-lang-select': isAbleToChangeLanguage,
                    'enter-prompt-without-lang-select': !isAbleToChangeLanguage }"
          ></EnterPrompt>
        </div>
      </div>
    </div>

    <h6 v-if="waiterOfcurrentUser" id="connected-user-container">
      Είστε συνδεδεμένος ως:
      <span id="name-of-connected-user">{{waiterOfcurrentUser.name}}</span>
    </h6>

    <div
      id="edit-catalogue-filters-container"
      v-if="isLoggedIn && waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToChangeCatalogue && !isLoading"
    >
      <div class="label-and-name" v-if="menuRestaurants.length>1">
        <div class="label">
          <h6 class="filter-title">Παράρτημα</h6>
          <select
            id="select-department-dropdown"
            @change="selectRestaurant()"
            style="width:167px"
            v-model="selectedRestaurantId"
          >
            <option
              v-for="restaurant in menuRestaurants"
              :key="restaurant.id"
              :value="restaurant.id"
            >{{getGreName(restaurant)}} {{restaurant.alias}} - id: {{restaurant.id}}</option>
          </select>
        </div>
      </div>
      <!-- <div id="select-type-of-edit-container">
        <div id="type-of-edit-container">
          <button
            @click="setTypeOfEdit('PRODUCTS')"
            class="edit-type-selection-button"
            :class="{ 'selected-edit-type': typeOfEdit=='PRODUCTS'}"
          >Προϊόντα</button>
          <button
            @click="setTypeOfEdit('SUBSELECTIONS')"
            class="edit-type-selection-button"
            :class="{ 'selected-edit-type': typeOfEdit=='SUBSELECTIONS'}"
          >Υποεπιλογές</button>
        </div>
      </div>-->
      <button id="create-category-button" @click="createCategory">
        <font-awesome-icon icon="plus" style="margin-right:6px" />Νέα κατηγορία
      </button>
      <p v-if="error" id="error-message">{{errorMessage}}</p>
    </div>

    <clip-loader v-if="searching" :loading="searching" size="30px" color="#003340" />

    <div
      v-if="typeOfEdit=='PRODUCTS' && selectedMenu && selectedMenu.categories && selectedMenu.categories.length>0 && isLoggedIn && waiterOfcurrentUser!=null && waiterOfcurrentUser.ableToChangeCatalogue"
      id="edit-catalogue-container"
    >
      <div id="categories-of-menu">
        <div
          v-for="category in selectedMenu.categories"
          :key="category.categoryId"
          class="category-edit-container"
          :class="{ 'selected-category': category.categoryId==selectedCategory.categoryId }"
          @click="selectCategory(category)"
        >
          <div class="category-name-and-features">
            <span class="category-name">{{category.names.translation[language].name}}</span>

            <small
              v-if="category.schedules != null && category.schedules.length > 0"
              class="category-feature-row"
            >
              <font-awesome-icon icon="qrcode" style="margin-right:4px" />
              <span>Ωράριο QR</span>
            </small>

            <small
              v-if="category.pdaSchedules != null && category.pdaSchedules.length > 0"
              class="category-feature-row"
            >
              <font-awesome-icon icon="clock" style="margin-right:4px" />
              <span>Ωράριο PDA</span>
            </small>

            <small v-if="category.onlyForPda" class="category-feature-row">
              <font-awesome-icon icon="user-cog" style="margin-right:4px" />
              <span>Μόνο PDA</span>
            </small>

            <small v-if="category.printSeparator" class="category-feature-row">
              <font-awesome-icon icon="print" style="margin-right:4px" />
              <span>Γραμμή</span>
            </small>

            <small
              v-if="category.bgColor != null && category.bgColor!='#ffffff' && category.bgColor!='#FFFFFF'"
              class="category-feature-row"
            >
              <span>Χρώμα:</span>
              <div class="category-bg-color-block" :style="{ backgroundColor: category.bgColor }"></div>
            </small>
          </div>

          <div class="edit-category-buttons-container">
            <button class="action-button edit-category-button">
              <font-awesome-icon @click="editCategory($event, category)" icon="edit" />
            </button>
            <button
              class="action-button delete-category-button"
              @click="deleteCategory($event, category)"
            >
              <font-awesome-icon icon="trash" />
            </button>
          </div>
        </div>
      </div>

      <div id="products-panel">
        <button v-if="selectedCategory" id="create-product-button" @click="createProduct">
          <font-awesome-icon icon="plus" style="margin-right:6px" />Νέο προϊόν
        </button>

        <div
          v-if="selectedCategory && selectedCategory.products.length>0"
          id="products-of-selected-category"
        >
          <div
            v-for="product in selectedCategory.products"
            :key="product.id"
            class="product-of-category-container"
            @click="editProduct(product)"
          >
            <div class="product-name-and-features">
              <span
                class="product-name"
                :class="{ 'unavailable-product': !product.available }"
              >{{ product.names.translation[language].name}} ({{product.price.toFixed(2)}}€{{product.perKg ? ' / κιλό' : ''}})</span>

              <small v-if="product.photoLink" class="product-feature-row">
                <font-awesome-icon
                  class="product-icon"
                  style="margin-right:4px; color: #30abd1"
                  icon="image"
                />
              </small>

              <div
                v-if="product.vegan || product.vegetarian || product.glutenFree"
                class="product-diatery-features"
              >
                <small v-if="product.vegan" class="product-feature-row">
                  <font-awesome-icon
                    class="product-icon"
                    style="margin-right:4px; color: #198b4a"
                    icon="leaf"
                  />
                </small>

                <small v-if="product.vegetarian" class="product-feature-row">
                  <font-awesome-icon
                    class="product-icon"
                    icon="seedling"
                    style="margin-right:4px; color: #198b4a"
                  />
                </small>

                <img
                  v-if="product.glutenFree"
                  src="../../assets/food-no-gluten.svg"
                  width="22px"
                  alt
                />
              </div>

              <small v-if="product.pdaProductOnly" class="product-feature-row">
                <font-awesome-icon class="product-icon" icon="user-cog" style="margin-right:4px" />
                <span style="font-size: 14px">Προϊόν μόνο για PDA</span>
              </small>

              <small v-if="product.stockEnabled" class="product-feature-row">
                <font-awesome-icon class="product-icon" icon="box-open" style="margin-right:4px" />
                <span style="font-size: 14px">Απόθεμα: {{product.stockAmount}}</span>
              </small>

              <small
                v-if="product.bgColor!=null && product.bgColor!='#ffffff' && product.bgColor!='#FFFFFF'"
                class="product-feature-row"
              >
                <span style="font-size: 14px">Χρώμα:</span>
                <div class="category-bg-color-block" :style="{ backgroundColor: product.bgColor }"></div>
              </small>

              <small
                v-if="selectedRestaurant.oxygenUrl!=null && product.vatPercentage==null"
                style="color: #d9534f; font-weight: 700"
              >*ΠΡΟΣΟΧΗ* Δεν έχετε ορίσει ΦΠΑ στο συγκεκριμένο προϊόν</small>
            </div>

            <div class="edit-products-buttons-container">
              <button class="action-button edit-product-button">
                <font-awesome-icon icon="edit" />
              </button>
              <button
                class="action-button delete-product-button"
                @click="deleteProduct($event, product)"
              >
                <font-awesome-icon icon="trash" />
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="selectedCategory && selectedCategory.products.length==0"
          id="products-of-selected-category"
        >
          <div>Δεν υπάρχει κάποιο προϊόν στη συγκεκριμένη κατηγορία</div>
        </div>
      </div>
    </div>

    <div
      id="general-errors-container"
      v-if="(!isLoggedIn || waiterOfcurrentUser==null || !waiterOfcurrentUser.ableToChangeCatalogue) && !isLoading"
    >
      <h6 class="info-message" v-if="!isLoggedIn">
        <font-awesome-icon style="color: #003340; margin-right:4px" icon="info-circle" />Για να επεξεργαστείτε τον κατάλογο πρέπει να συνδεθείτε. Πηγαίντε πίσω και κάντε είσοδο πάνω δεξιά με το pin σας. Ξαναμπείτε μετά εδώ ώστε να επεξεργαστείτε τον κατάλογο
      </h6>
      <h6
        class="info-message"
        v-if="isLoggedIn && (waiterOfcurrentUser==null || !waiterOfcurrentUser.ableToChangeCatalogue)"
      >
        <font-awesome-icon style="color: #003340; margin-right:4px" icon="info-circle" />Δεν έχετε δικαιώμα επεξεργασίας του καταλόγου
      </h6>
    </div>
    <div
      @click="onMaskClick"
      :class="{
        mask:
          isEntranceOpen ||
          isLanguageModalOpen
      }"
    ></div>
    <PoweredByFooter v-if="!isLoading"></PoweredByFooter>
    <EditCategoryModal
      ref="editCategoryModal"
      v-bind:class="{ hide: !isEditCategoryModalOpen}"
      :selectedCategory="selectedCategory"
      :restaurantId="selectedRestaurantId"
      :categoriesCount="selectedMenu && selectedMenu.categories ? selectedMenu.categories.length : 0"
      :isCreatingCategory="isCreatingCategory"
      :authToken="authToken"
      :jwt="jwt"
      @category-updated="onCategoryUpdated"
    ></EditCategoryModal>
    <EditProductModal
      ref="editProductModal"
      v-bind:class="{ hide: !isEditProductModalOpen}"
      :selectedProduct="selectedProduct"
      :productCategoryId="selectedCategory ? selectedCategory.categoryId : null"
      :productsCount="selectedCategory && selectedCategory.products ? selectedCategory.products.length : 0"
      :isCreatingProduct="isCreatingProduct"
      :categories="selectedMenu && selectedMenu.categories ? selectedMenu.categories : []"
      :subCategoriesOfMenu="subCategoriesOfMenu"
      :restaurantId="selectedRestaurantId"
      :storeId="store ? store.id : null"
      :restaurant="selectedRestaurant"
      :authToken="authToken"
      :jwt="jwt"
      @category-updated="onCategoryUpdated"
    ></EditProductModal>
  </div>
</template>

<script>

import Store from "../Store";
import StoreApi from "../../api/stores";
import MenuApi from "../../api/menu";
import ProfileDropdown from "../ProfileDropdown";
import EnterPrompt from "../EnterPrompt";
import LanguageSelect from "../LanguageSelect";
import BackToServices from "../BackToServices.vue";
import EditCategoryModal from "../EditCategoryModal";
import EditProductModal from "../EditProductModal";

import ClipLoader from "vue-spinner/src/ClipLoader.vue";


import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import PoweredByFooter from "../PoweredByFooter.vue";

export default {
  name: "EditCatalogue",
  components: {
    Store,
    ProfileDropdown,
    EnterPrompt,
    Loading,
    LanguageSelect,
    BackToServices,
    ClipLoader,
    EditCategoryModal,
    EditProductModal,
    PoweredByFooter
  },
  props: [""],
  data() {
    return {
      store: undefined,
      isLoading: true,
      menuRestaurants: [],
      selectedRestaurant: null,
      selectedRestaurantId: null,
      selectedMenu: null,
      subCategoriesOfMenu: [],
      selectedCategory: null,
      selectedProduct: null,
      isCreatingCategory: false,
      isCreatingProduct: false,
      from: undefined,
      fromRouteName: '',
      shouldShowEnterPrompt: false,
      isApplication: false,
      isAbleToChangeLanguage: true,
      waiters: [],
      waiterOfcurrentUser: null,
      searching: false,
      error: false,
      errorMessage: '',
      typeOfEdit: 'PRODUCTS'
    };
  },
  watch: {
    isEditCategoryModalOpen: function (newVal, oldVal) {
      let htmlElement = document.querySelector("html");
      if (newVal == true) {
        htmlElement.style.overflow = "hidden";
      } else {
        htmlElement.style.overflow = "auto";
      }
    },
    isEditProductModalOpen: function (newVal, oldVal) {
      let htmlElement = document.querySelector("html");
      if (newVal == true) {
        htmlElement.style.overflow = "hidden";
      } else {
        htmlElement.style.overflow = "auto";
      }
    }
  },
  async mounted() {
    this.isLoading = true;

    let storeId = this.$router.currentRoute.params.storeId;
    let tableId = this.$router.currentRoute.params.tableId;

    if (this.$route.params.store) {
      this.store = this.$route.params.store;
    } else if (!this.store) {
      this.store = await StoreApi.getStoreById(storeId);
    }
    this.$store.dispatch("setTableId", tableId)

    let serviceName = {
      GRE: {
        name: "Διαχείριση καταλόγου"
      },
      ENG: {
        name: "Edit Catalogue"
      },
    };
    this.$store.dispatch("setServiceName", serviceName);
    this.setTitle();
    if (this.isLoggedIn) {

      try {
        this.menuRestaurants = await StoreApi.getMenuRestaurants(this.store.id, this.authToken, this.jwt);
        this.selectedRestaurant = this.menuRestaurants[0];
        this.selectedRestaurantId = this.selectedRestaurant.id;
        let restaurantIds = this.menuRestaurants.map(restaurant => restaurant.id);
        this.waiters = await StoreApi.fetchAllWaiters(restaurantIds, this.authToken, this.jwt);
        this.waiterOfcurrentUser = this.waiters.find(waiter => waiter.userId == this.currentUserId);

        if (this.waiterOfcurrentUser && !this.waiterOfcurrentUser.ableToChangeCatalogue) {
          this.isLoading = false;
          return;
        }

        let apiResponses = await Promise.all([MenuApi.getMenuForEdit(this.selectedRestaurantId, this.authToken, this.jwt), MenuApi.getSubSelectionCategoriesForEdit(this.selectedRestaurantId, this.authToken, this.jwt)]).then(data => {
          return {
            selectedMenu: data[0],
            subCategories: data[1]
          }
        });

        this.selectedMenu = apiResponses.selectedMenu;
        this.subCategoriesOfMenu = apiResponses.subCategories;

        if (this.selectedMenu && this.selectedMenu.categories.length > 0) {
          this.selectedMenu.categories = this.selectedMenu.categories.filter(category => category.categoryId != 17);
        }

        this.selectedCategory = this.selectedMenu && this.selectedMenu.categories.length > 0 ? this.selectedMenu.categories[0] : null;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.$store.dispatch("setUserData", {});
        let queryObject = null;
        if (this.$route.query && this.$route.query.clientId != undefined) {
          queryObject = { clientId: this.$route.query.clientId };
        }

        this.$router.push({ name: "services", params: { tableId: this.tableId }, query: queryObject });
      }

    } else {
      this.isLoading = false;

      this.$store.dispatch("setUserData", {});
      let queryObject = null;
      if (this.$route.query && this.$route.query.clientId != undefined) {
        queryObject = { clientId: this.$route.query.clientId };
      }

      this.$router.push({ name: "services", params: { tableId: this.tableId }, query: queryObject });
    }

  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRouteName = from.name;
      vm.from = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEntranceOpen) {
      this.closeEntrance();
      //below is needed for same reason as above
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isLanguageModalOpen) {
      this.$store.dispatch("closeLanguageModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isEditCategoryModalOpen) {

      this.$store.dispatch("closeEditCategoryModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else if (this.isEditProductModalOpen) {

      this.$store.dispatch("closeEditProductModal");
      //below is needed as if route is the same as before after next(false)
      //browser autoscrolls to top of page
      window.history.scrollRestoration = "manual";
      next(false);
    } else {
      next();
    }
  },
  beforeDestroy() {

  },
  computed: {
    tableId() {
      return this.$store.getters.getTableId;
    },

    isEntranceOpen() {
      return this.$store.getters.getSlideEntranceIn;
    },

    isEditCategoryModalOpen() {
      return this.$store.state.editCategoryModalOpen;
    },

    isEditProductModalOpen() {
      return this.$store.state.editProductModalOpen;
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    isLanguageModalOpen() {
      return this.$store.getters.isLanguageModalOpen;
    },

    language() {
      return this.$store.getters.getLanguage;
    },

    currentGreekDate() {
      return this.$store.getters.getCurrentGreekDate;
    },

    authToken() {
      return this.$store.getters.getUserAuthToken;
    },

    jwt() {
      return this.$store.getters.getUserJWT;
    },

    currentUserId() {
      return this.$store.getters.getUserId;
    },

    storeName() {
      if (this.store) {
        return this.store.names && this.store.names.translation[this.language]
          ? this.store.names.translation[this.language].name
          : this.store.name;
      }
    },

    title() {
      return `Εdit catalogue | Fluter`;
    },

  },

  methods: {

    getGreName(restaurant) {
      let greInfo = restaurant.names.find(name => name.language == 'GRE');
      return greInfo.name;
    },

    onMaskClick: function () {
      if (this.isEntranceOpen) {
        this.closeEntrance();
      } else if (this.isLanguageModalOpen) {
        this.$store.dispatch("closeLanguageModal");
      }
    },

    clearErrors() {
      this.error = false;
      this.errorMessage = '';
    },

    setTypeOfEdit(typeOfEdit) {
      this.typeOfEdit = typeOfEdit;
    },

    closeEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceOut");

      this.$store.dispatch("shouldNotSlideEntranceIn");

      setTimeout(() => {
        this.$store.dispatch("resetEntranceState");
        this.$store.dispatch("setEntranceMessage", "");

        this.$store.dispatch("resetVerificationState");
        this.$store.dispatch("setVerificationMessage", "");
      }, 850);
    },

    initiateEntrance: function () {
      this.$store.dispatch("shouldSlideEntranceIn");
    },

    async selectRestaurant() {
      this.isLoading = true;
      this.selectedRestaurant = this.menuRestaurants.find(menuRestaurant => menuRestaurant.id == this.selectedRestaurantId);

      let apiResponses = await Promise.all([MenuApi.getMenuForEdit(this.selectedRestaurantId, this.authToken, this.jwt), MenuApi.getSubSelectionCategoriesForEdit(this.selectedRestaurantId, this.authToken, this.jwt)]).then(data => {
        return {
          selectedMenu: data[0],
          subCategories: data[1]
        }
      });

      this.selectedMenu = apiResponses.selectedMenu;
      this.subCategoriesOfMenu = apiResponses.subCategories;

      if (this.selectedMenu && this.selectedMenu.categories.length > 0) {
        this.selectedMenu.categories = this.selectedMenu.categories.filter(category => category.categoryId != 17);
      }

      this.selectedCategory = this.selectedMenu && this.selectedMenu.categories.length > 0 ? this.selectedMenu.categories[0] : null;

      this.isLoading = false;
    },

    selectCategory(category) {
      this.selectedCategory = category;
    },

    editCategory(event, category) {
      event.stopPropagation();
      this.selectedCategory = category;
      this.isCreatingCategory = false;
      this.$store.dispatch("openEditCategoryModal");
    },

    createCategory() {
      this.selectedCategory = {
        categoryId: null,
        names: {
          translation: {
            GRE: { name: "Νέα κατηγορία", description: "" },
            ENG: { name: "New category", description: "" },
          },
        },
        products: [],
      };
      this.isCreatingCategory = true;
      this.$store.dispatch("openEditCategoryModal");
    },

    async onCategoryUpdated() {
      this.isLoading = true;
      let previouslySelectedCategoryId = this.selectedCategory ? this.selectedCategory.categoryId : null;

      this.selectedMenu = await MenuApi.getMenuForEdit(this.selectedRestaurantId, this.authToken, this.jwt);

      if (this.selectedMenu && this.selectedMenu.categories.length > 0) {
        this.selectedMenu.categories = this.selectedMenu.categories.filter(category => category.categoryId != 17);
      }

      this.selectedCategory = this.selectedMenu && this.selectedMenu.categories.length > 0
        ? this.selectedMenu.categories.find(category => category.categoryId == previouslySelectedCategoryId) || this.selectedMenu.categories[0]
        : null;

      this.isLoading = false;
    },

    deleteCategory(event, category) {
      event.stopPropagation();
      this.$confirm({
        message: `*ΠΡΟΣΟΧΗ* Είστε σίγουρος για την διαγραφή της κατηγορίας ${category.names.translation.GRE.name};`,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.isLoading = true;
            await MenuApi.deleteCategory(this.selectedRestaurantId, category.categoryId, this.authToken, this.jwt);
            await this.selectRestaurant();
            this.isLoading = false;
          }
        }
      });
    },

    editProduct(product) {
      this.selectedProduct = product;
      this.isCreatingProduct = false;
      this.$store.dispatch("openEditProductModal");
    },

    createProduct() {
      this.selectedProduct = {
        id: null,
        names: {
          translation: {
            GRE: { name: "Νέο προϊόν", details: "" },
            ENG: { name: "New product", details: "" },
          },
        },
      };
      this.isCreatingProduct = true;
      this.$store.dispatch("openEditProductModal");
    },

    deleteProduct(event, product) {
      event.stopPropagation();
      this.$confirm({
        message: `*ΠΡΟΣΟΧΗ* Είστε σίγουρος για την διαγραφή του ${product.names.translation.GRE.name};`,
        button: {
          yes: 'Ναι',
          no: 'Όχι'
        },
        callback: async confirm => {
          if (confirm) {
            this.isLoading = true;
            await MenuApi.deleteProduct(this.selectedRestaurantId, product.id, this.authToken, this.jwt);
            await this.onCategoryUpdated();
            this.isLoading = false;
          }
        }
      });
    },

    setTitle() {
      try {
        document.title = this.title;
      } catch (error) {
        console.log("Could not set title");
      }
    }
  },
};
</script>

<style scoped>
.margin-top-0 {
  margin-top: 0px !important;
}

.margin-top-12 {
  margin-top: 12px !important;
}

.font-italic {
  font-style: italic;
}

.mt-1 {
  margin-top: 4px;
}

.text-success {
  color: #5cb85c;
}

.text-info {
  color: #5bc0de;
}

.text-warning {
  color: #f0ad4e;
}

.text-dark {
  color: #343a40;
}

.text-primary {
  color: #007bff;
}

.text-center {
  text-align: center;
}

.product-diatery-features {
  display: flex;
  flex-direction: row;
}

.product-icon {
  font-size: 17px !important;
}

.product-feature-row,
.category-feature-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 0;
  color: #6c7174;
}

.product-bg-color-block,
.category-bg-color-block {
  height: 12px;
  width: 26px;
  border-radius: 4px;
  margin-left: 2px;
  border: 1px solid #6c757d;
}

.action-button {
  padding: 4px 8px 4px 8px;
  border-radius: 6px;
  cursor: pointer;
}

.product-of-category-container {
  display: flex;
  flex-direction: column;
  padding: 3px 3px 6px 3px;
  border-bottom: 1px solid #b3b3b3;
}

.product-name {
  font-size: 15px;
}

.unavailable-product {
  text-decoration: line-through;
  color: rgb(71, 71, 71);
}

.edit-category-button {
  color: rgb(255, 255, 255);
  background-color: #17b86e;
  font-size: 12px;
}

.edit-product-button {
  color: rgb(255, 255, 255);
  background-color: #0275d8;
  font-size: 12px;
  margin-right: 26px;
}

.delete-product-button {
  color: rgb(255, 255, 255);
  background-color: #dc3545;
  font-size: 12px;
}

.delete-category-button {
  color: rgb(255, 255, 255);
  background-color: #dc3545;
  font-size: 12px;
}

#history-screen {
  margin: 0px;
  box-sizing: border-box;
  padding: 0px;
  overflow-x: hidden;
  background: #fcfcfc;
  min-height: 100vh;
  z-index: 0;
  overflow-x: hidden !important;
}

#banner {
  position: relative;
  width: 100vw;
  height: 55vh;
  min-height: 220px;
}

#banner-image {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

#store-info {
  position: absolute;
  top: 15%;
  right: 5%;
  width: 30%;
  min-width: 400px;
  background: white;
  border-radius: 18px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.36), 2px 2px 4px rgba(0, 0, 0, 0.48);
}

#store {
  cursor: unset;
}

#error-message {
  margin-left: 10px;
  margin-top: 4px;
  margin-bottom: 0px;
  font-size: 14px;
  font-weight: 600;
  color: #d9534f;
}

#edit-catalogue-filters-container {
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #a2a2a2;
}

#create-category-button {
  display: flex;
  align-items: center;
  margin-left: 8px;
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  background-color: #28a745;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

#create-category-button:hover {
  background-color: #218838;
}

#edit-catalogue-container {
  display: flex;
  flex-direction: row;
  margin-left: 8px;
  margin-right: 6px;
}

#categories-of-menu {
  display: flex;
  flex-direction: column;
  width: 33%;
  max-height: 650px;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

#categories-of-menu::-webkit-scrollbar {
  display: none; /* Chrome, Safari, newer Edge */
}

.category-edit-container {
  display: flex;
  flex-direction: column;
  border: solid 1px #b3b3b3;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 3px;
  padding-right: 2px;
  border-radius: 4px;
}

.edit-products-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-right: 4px;
}

.edit-category-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 4px;
}

.selected-category {
  background-color: #b8daff;
}

.category-name-and-features {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
}

.product-name-and-features {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
}

.category-name {
  font-size: 15px;
  font-weight: 500;
}

#products-panel {
  display: flex;
  flex-direction: column;
  width: 67%;
  margin-left: 2px;
}

#select-type-of-edit-container {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-bottom: 1vh;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  padding: 2x 0 7.5px 0;
  color: black;
}

#type-of-edit-container {
  display: flex;
  align-items: center;
  overflow-x: scroll;
  scrollbar-width: none;
  margin-top: 2px;
  margin-bottom: 8px;
  margin-left: 8px;
}

.edit-type-selection-button {
  padding: 5px 5px 5px 5px;
  border-radius: 4px;
  cursor: pointer;
  color: #0d6efd;
  background-color: #ffffff;
  border: 1px solid #0d6efd;
  font-size: 13px;
  font-weight: 600;
  margin-top: 0px;
  margin-right: 6px;
  white-space: nowrap;
}

.selected-edit-type {
  color: #ffffff !important;
  background-color: #0d6efd !important;
}

#create-product-button {
  display: flex;
  align-items: center;
  align-self: flex-start;
  margin-bottom: 8px;
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  background-color: #0275d8;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

#products-of-selected-category {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 650px;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

#products-of-selected-category::-webkit-scrollbar {
  display: none;
}

#general-errors-container {
  min-height: 600px !important;
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
}

#connected-user-container {
  margin-bottom: 2px;
  margin-left: 8px;
  margin-top: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #003340;
}

#name-of-connected-user {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #198b4a !important;
}

.label-and-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-content: flex-start;
  margin-top: 8px;
  margin-left: 8px;
}

.filter-title {
  font-size: 15px;
  font-weight: 700;
}

.label {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

select {
  display: flex;
  align-self: center;
  justify-self: center;
  -webkit-appearance: auto !important;
  box-shadow: inset 0px 0px 2px rgba(116, 135, 150, 0.2),
    inset 1px 1px 2px rgba(116, 135, 150, 0.36);
  border-radius: 6px;
  margin-bottom: 0.5rem;
  margin-left: 7px;
  padding: 2px;
  color: #198b4a !important;
  font-weight: bold;
  background: #f7f7f7;
}

@media screen and (max-width: 800px) {
  select {
    font-size: 14.5px;
  }
}
@media screen and (max-width: 300px) {
  select {
    font-size: 12px;
  }
}

option {
  color: #198b4a !important;
  font-weight: 600;
}

#upper-bar {
  position: absolute;
  top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;

  padding-right: 1%;
}

#profile-and-cart {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
}

#language-select {
  position: absolute;
  right: 200px;
  top: 8px;
  cursor: pointer;
}

.language-position-in-login {
  right: 159px !important;
  z-index: 202;
}

#enter-prompt {
  position: absolute;
  top: 8px;
  right: 88px !important;
  z-index: 201;
}

#profile-dropdown {
  position: absolute;
  top: 0px;
  right: 88px !important;
  z-index: 201;
}

#back-to-services {
  position: fixed;
  left: 80px;
  box-shadow: 3px 4px 8px rgba(0, 0, 0, 0.32), 3px 4px 8px rgba(0, 0, 0, 0.46);
}

#logo-container {
  background: white !important;
  /* height: 45px; */
  margin-left: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  justify-content: center;
  padding: 0px 16px 0px 12px;
  border-radius: 12px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.24), 2px 2px 4px rgba(0, 0, 0, 0.36);
}

#logo {
  cursor: pointer;
  height: 40px;
  width: auto;
}

#link-to-landing {
  text-decoration: none;
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 204;
  opacity: 1;
  transition: 0.67s;
}

.hide {
  visibility: hidden;
  display: none;
}

.low-visibility {
  opacity: 0.5;
}

.info-message {
  font-size: 15px;
  font-weight: 600;
  color: #003340;
}

#loading-mask {
  position: fixed;
  top: 0;
}

@media screen and (max-width: 1018px) {
  #language-select {
    left: unset;
    top: 5px !important;
    right: 20px;
    cursor: pointer;
  }

  .language-position-in-login {
    right: 20px !important;
    z-index: 202;
  }

  .no-bottom-margin {
    margin-bottom: 0px !important;
  }

  #profile-dropdown {
    right: 20px !important;
  }

  .profile-dropdown-with-lang-select {
    top: 58px !important;
  }

  .profile-dropdown-without-lang-select {
    top: 2px !important;
  }

  #enter-prompt {
    right: 20px !important;
    margin: 0;
  }

  .enter-prompt-with-lang-select {
    top: 56px !important;
  }

  .enter-prompt-without-lang-select {
    top: 5px !important;
  }

  #back-to-services {
    left: 20px;
  }

  #logo-container {
    min-width: 95px !important;
    justify-content: flex-start;
    margin-left: 20px;
  }

  #logo {
    height: 33px;
  }

  #banner {
    height: 40vh;
  }

  #store-info {
    top: 165px;
    width: 90%;
    left: 5%;
    min-width: 200px;
    max-height: 112px;
  }

  #upper-bar {
    top: 15px;
    height: unset;
  }
}

@media screen and (max-width: 350px) {
  #store-info {
    top: 140px;
  }
}

@media screen and (max-width: 1018px) {
  #banner {
    height: 290px !important;
  }
}

@media screen and (max-width: 530px) {
  #banner {
    height: 280px !important;
  }
}

@media screen and (max-width: 350px) {
  #banner {
    height: 250px !important;
  }
}

@media screen and (max-width: 330px) {
  #banner {
    height: 235px !important;
  }
}
</style>
